import React from 'react';

interface IWarning {
  onClick: () => void
  onAdvancedClick: () => void
}

const Warning: React.FC<IWarning> = ({ onClick, onAdvancedClick }) => (
  <div className="web3-wc_hd-wallet_warning web3-wc_hd-wallet__common-container">
    <h4>Before proceeding make sure</h4>
    <ol>
      <li>The device is plugged in via USB NOT bluetooth</li>
      <li>Ledger Live app is closed</li>
      <li>The device is unlocked and in the Ethereum app</li>
      <li>&laquo;Blind signing&raquo; is enabled on the device</li>
    </ol>
    <button type="button" className="web3-wc_hd-wallet_warning_confirm" onClick={onClick}>Continue</button>
    <a onClick={onAdvancedClick} className="web3-wc_hd-wallet-advanced">Advanced  - select derivation path</a>
  </div>
);

export default Warning;
